const brighton = [
  {
    id: 0,
    pais: "inglaterra",
    liga: "premier-league",
    time: "brighton",
    nome: "Brighton & Hove Albion 25/26 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "brighton & hove albion",
      "the seagulls",
      "brighton 2025",
      "2025 brighton",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/brighton/25-26-01/uni0.png",
      "/images/inglaterra/premier-league/brighton/25-26-01/uni1.png",
      "/images/inglaterra/premier-league/brighton/25-26-01/uni2.png",
      "/images/inglaterra/premier-league/brighton/25-26-01/uni3.png",
      "/images/inglaterra/premier-league/brighton/25-26-01/uni4.png",
    ],
  },
  {
    id: 1,
    pais: "inglaterra",
    liga: "premier-league",
    time: "brighton",
    nome: "Brighton & Hove Albion 25/26 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "brighton & hove albion",
      "the bees",
      "brighton 2025",
      "2025 brighton",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/brighton/25-26-02/uni0.png",
      "/images/inglaterra/premier-league/brighton/25-26-02/uni1.png",
      "/images/inglaterra/premier-league/brighton/25-26-02/uni2.png",
      "/images/inglaterra/premier-league/brighton/25-26-02/uni3.png",
      "/images/inglaterra/premier-league/brighton/25-26-02/uni4.png",
    ],
  },
  {
    id: 2,
    pais: "inglaterra",
    liga: "premier-league",
    time: "brighton",
    nome: "Brighton & Hove Albion 24/25 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "brighton & hove albion",
      "the bees",
      "brighton 2024",
      "2024 brighton",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/brighton/24-25-01/uni0.jpg",
      "/images/inglaterra/premier-league/brighton/24-25-01/uni1.jpg",
      "/images/inglaterra/premier-league/brighton/24-25-01/uni2.jpg",
      "/images/inglaterra/premier-league/brighton/24-25-01/uni3.jpg",
      "/images/inglaterra/premier-league/brighton/24-25-01/uni4.jpg",
    ],
  },
  {
    id: 3,
    pais: "inglaterra",
    liga: "premier-league",
    time: "brighton",
    nome: "Brighton & Hove Albion 24/25 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "brighton & hove albion",
      "the bees",
      "brighton 2024",
      "2024 brighton",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/brighton/24-25-02/uni0.jpg",
      "/images/inglaterra/premier-league/brighton/24-25-02/uni1.jpg",
      "/images/inglaterra/premier-league/brighton/24-25-02/uni2.jpg",
      "/images/inglaterra/premier-league/brighton/24-25-02/uni3.jpg",
      "/images/inglaterra/premier-league/brighton/24-25-02/uni4.jpg",
    ],
  },
  {
    id: 4,
    pais: "inglaterra",
    liga: "premier-league",
    time: "brighton",
    nome: "Brighton & Hove Albion 24/25 - Uniforme de Treino",
    tipo: "masculino",
    aliases: [
      "brighton & hove albion",
      "the bees",
      "brighton 2024",
      "2024 brighton",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/brighton/24-25-05-tc/uni0.jpeg",
      "/images/inglaterra/premier-league/brighton/24-25-05-tc/uni1.jpeg",
      "/images/inglaterra/premier-league/brighton/24-25-05-tc/uni2.jpeg",
      "/images/inglaterra/premier-league/brighton/24-25-05-tc/uni3.jpeg",
      "/images/inglaterra/premier-league/brighton/24-25-05-tc/uni4.jpeg",
    ],
  },
  {
    id: 5,
    pais: "inglaterra",
    liga: "premier-league",
    time: "brighton",
    nome: "Brighton & Hove Albion 23/24 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "brighton & hove albion",
      "the bees",
      "brighton 2024",
      "2024 brighton",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/brighton/23-24-02/uni0.jpeg",
      "/images/inglaterra/premier-league/brighton/23-24-02/uni1.jpeg",
      "/images/inglaterra/premier-league/brighton/23-24-02/uni2.jpeg",
      "/images/inglaterra/premier-league/brighton/23-24-02/uni3.jpeg",
      "/images/inglaterra/premier-league/brighton/23-24-02/uni4.jpeg",
    ],
  },
];

export default brighton;
